import { useQueries } from '@tanstack/react-query';
import { useMemo } from 'react';

import { _getWalletRecipients } from '@/api/address-book-bff/queries';
import {
  getTransactionWalletAddresses,
  type TransactionListItem,
} from '@/features/transactions/utils/transaction-list';
import { getNormalizedSuiAddress } from '@/shared/modules/wallet/send/recipient';

import { getRecipientLabel } from '../transfers/send/recipient-name';

export const useTransactionCounterpartyDisplayNames = (
  transactions: readonly TransactionListItem[],
) => {
  const walletAddresses = useMemo(
    () => getTransactionWalletAddresses(transactions),
    [transactions],
  );
  const walletRecipientQueries = useQueries({
    queries: walletAddresses.map((address) => _getWalletRecipients(address)),
  });

  return useMemo(() => {
    const displayNames = new Map<string, string>();
    walletRecipientQueries.forEach((query, index) => {
      const address = walletAddresses[index];
      if (!address) return;
      const recipient = query.data?.recipients.find(
        (candidate) => getNormalizedSuiAddress(candidate.wallet.address) === address,
      );
      if (recipient) displayNames.set(address, getRecipientLabel(recipient));
    });
    return displayNames;
  }, [walletAddresses, walletRecipientQueries]);
};
